import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";
import DataTableComponent from "../../tools/DataTableComponent";
import * as Yup from "yup";
import { useFormik } from "formik";
import "../Validations/errors.css"


const validationsSchema = Yup.object({
    nameLat: Yup.string()
        .required("Le nom est obligatoire")
        .min(2, "Minimum 2 caractères")
        .max(100, "Maximum 100 caractères"),

    postalCode: Yup.string()
        .required("Le code postal est obligatoire")
        .min(2, "Minimum 2 caractères")
        .max(20, "Code postal invalide"),

    countryId: Yup.number()
        .required("Le pays est obligatoire")
});

function Cities() {
    const [cities, setCities] = useState([]);
    const [countries, setCountries] = useState([]);

    const [selectedCity, setSelectedCity] = useState(null);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("token");
    const baseUrl = process.env.REACT_APP_BASE_URL;

    useEffect(() => {
        fetchCities();
        fetchCountries();
    }, []);

    const fetchCities = () => {
        axiosInstance.get(`${baseUrl}/api/Cities/getCities`)
            .then(res => setCities(res.data))
            .catch(() => console.log("Impossible de charger."))
            .finally(() => setLoading(false));
    };

    const fetchCountries = () => {
        axiosInstance.get(`${baseUrl}/api/Countries/getCountries`)
            .then(res => setCountries(res.data))
            .catch(() => console.log("Impossible de charger."));
    };

    const formik = useFormik({
        initialValues: {
            id: 0,
            nameLat: "",
            nameAr: "",
            postalCode: "",
            countryId: "",
            countryName: ""
        },
        validationSchema: validationsSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setErrors, resetForm }) => {
            const payload = {
                ...values,
                countryId: parseInt(values.countryId, 10)
            };

            const url = selectedCity
                ? `${baseUrl}/api/Cities/UpdateCity`
                : `${baseUrl}/api/Cities/CreateCity`;

            try {
                const res = await axiosInstance.post(url, payload);

                // 🔴 erreurs backend (ServiceResponse)
                if (res.data && res.data.success === false) {
                    setErrors(res.data.errors);
                    return;
                }

                window.$("#modalForm").modal("hide");
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Opération réussie",
                    showConfirmButton: false,
                    timer: 2000
                });

                fetchCities();
                resetForm();
                setSelectedCity(null);

            } catch (err) {
                Swal.fire("Erreur", "Erreur serveur", "error");
            }
        }
    });
    const resetForm = () => {
        formik.resetForm();
        setSelectedCity(null);
    };
    const handleEdit = (city) => {
        setSelectedCity(city);
        formik.setValues({
            id: city.id,
            nameLat: city.nameLat,
            nameAr: city.nameAr,
            postalCode: city.postalCode,
            countryId: city.countryId,
            countryName: ""
        });

        setTimeout(() => window.$("#modalForm").modal("show"), 100);
    };


    const handleDelete = (id) => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer",
            cancelButtonText: "Annuler"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance.post(`${baseUrl}/api/Cities/DeleteCity`,
                    { 'id': id, 'idString': '' }).then(() => {
                        Swal.fire("Supprimé", "La ville a été supprimée", "success");
                        setCities((prev) => prev.filter((c) => c.id !== id));
                    }).catch(() => console.log("Echec de l'opération."));
            }
        });
    };

    const columnsMapping = {
        nameLat: "Nom de la ville",
        postalCode: "Code postal",
        countryName: "Pays"
    };

    return (
        <div className="container-fluid mt-4">
            <h3 className="text-center my-3">Gestion des Villes</h3>

            <button className="btn btn-primary btn-ajouter mb-3" data-toggle="modal" data-target="#modalForm" ><i className="fas fa-plus"></i>Ajouter</button>

            {loading ? (
                <p>Chargement...</p>
            ) : (
                <DataTableComponent
                    title="Liste des villes"
                    columns={["nameLat", "postalCode", "countryName"]}
                    columnsMapping={columnsMapping}
                    keyField="id"
                    data={cities}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                />
            )}

            <div className="modal fade" id="modalForm" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{selectedCity ? "Modifier" : "Ajouter"} une ville</h5>
                            <button type="button" className="close" data-dismiss="modal" onClick={resetForm}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Nom</label>
                                <input
                                    type="text"
                                    name="nameLat"
                                    value={formik.values.nameLat}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className={`form-control mb-2 ${formik.touched.nameLat && formik.errors.nameLat ? "is-invalid" : ""
                                        }`}
                                />

                                {formik.touched.nameLat && formik.errors.nameLat && (
                                    <div className="invalid-feedback">
                                        {formik.errors.nameLat}
                                    </div>
                                )}
                            </div>
                            <div className="form-group">
                                <label>Code postal</label>
                                <input
                                    type="text"
                                    name="postalCode"
                                    value={formik.values.postalCode}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className={`form-control mb-2 ${formik.touched.postalCode && formik.errors.postalCode ? "is-invalid" : ""
                                        }`}
                                />

                                {formik.touched.postalCode && formik.errors.postalCode && (
                                    <div className="invalid-feedback">
                                        {formik.errors.postalCode}
                                    </div>
                                )}
                            </div>
                            <div className="form-group">
                                <label>Pays</label>
                                <select
                                    name="countryId"
                                    value={formik.values.countryId}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className={`form-control mb-2 ${formik.touched.countryId && formik.errors.countryId ? "is-invalid" : ""
                                        }`}
                                >
                                    <option value="">-- Sélectionnez --</option>
                                    {countries.map((c) => (
                                        <option key={c.id} value={c.id}>
                                            {c.nameLat}
                                        </option>
                                    ))}
                                </select>

                                {formik.touched.countryId && formik.errors.countryId && (
                                    <div className="invalid-feedback">
                                        {formik.errors.countryId}
                                    </div>
                                )}

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={resetForm}>Annuler</button>
                            <button type="button" className="btn btn-primary" onClick={formik.handleSubmit}>Sauvegarder</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cities;
